interface MaterialIconProps {
  icon: string;
  className?: string;
}

function MaterialIcon({ icon, className }: MaterialIconProps) {
  return (
    <span
      className={`material-symbols-outlined flex items-baseline ${className}`}
    >
      {icon}
    </span>
  );
}

export default MaterialIcon;
